window.PlummeI18n.register('en', {
  'bank.group.toast.booked': 'The matching group has been posted together.',
  'bank.group.err.bookUnavailable': 'The matching group was approved, but posting is unavailable.',
  'bank.group.err.bookFailed': 'Could not post the matching group.',
  'bank.group.book': 'Post group',
  'bank.resolve.reversePaymentInfo': 'Reversal cancels the payment with an audit trail, reopens the supplier invoice, and opens the bank line for a new review.',
  'err.bankMatchReversalReason': 'Enter a reason for reversing the bank match.',
});
